export default {
  pageTitle: 'Membership plans',
  pageDesc: 'Quotas are shared by the company. Platform plans are ranked by price: you can only upgrade to a more expensive plan while the current one is active. You may renew the current time-limited plan before it expires; the end date is extended by the plan term. When a plan expires it falls back to the free default tier; existing data is kept. Switching plans replaces the current one with no proration. Custom plans are granted in admin.',
  currentTitle: 'Current plan',
  noPlan: 'No plan yet',
  expired: 'Expired',
  fallenBackTitle: 'Fell back to the free plan',
  fallenBack: 'The paid plan has expired and was replaced with the free default tier. Existing albums, events, and forms are kept. If usage already exceeds the free limits, upgrade before creating or uploading more.',
  soonExpireTitle: 'Plan expiring soon',
  soonExpire: 'The current plan expires within 7 days. After that it falls back to the free tier. Renew in advance to keep the current entitlements.',
  permanent: 'Never expires',
  validUntil: 'Valid until {date}',
  usageTitle: 'Usage',
  albums: 'Photo Live',
  activities: 'Events',
  registrations: 'Forms',
  donations: 'Donations',
  nameCards: 'Name cards',
  sms: 'SMS',
  storage: 'Photo Live storage',
  unlimited: 'Unlimited',
  catalogTitle: 'Public plans',
  upgradeOrCustom: 'Upgrade or custom plan',
  upgradeOrCustomHint: 'See upgrade tiers. Custom plans are activated by invitation.',
  customInviteHint: 'Custom plans cannot be purchased here; they require a platform invitation.',
  currentBadge: 'Current',
  defaultBadge: 'Default',
  buy: 'Buy',
  upgrade: 'Upgrade',
  renew: 'Renew',
  freeActivate: 'Activate free',
  cannotDowngradeFree: 'A paid plan is active; you cannot switch back to free',
  cannotDowngrade: 'While the current plan is active, you can only upgrade to a higher-priced plan',
  cannotChangeCustom: 'This company is on a custom plan. Ask the platform to change it in admin.',
  buySuccess: 'Plan activated',
  renewSuccess: 'Renewed. The end date has been extended.',
  buyConfirm: 'Activating “{name}” replaces the current plan. The term starts now, with no proration or stacking. Continue?',
  renewConfirm: 'Renewing “{name}” extends the end date by {n} days. Remaining time is kept. Continue?',
  priceFree: 'Free',
  durationDays: '{n} days',
  quotaAlbums: 'Photo Live {n}',
  quotaActivities: 'Events {n}',
  quotaRegistrations: 'Forms {n}',
  quotaDonations: 'Donations (coming soon)',
  quotaNameCards: 'Name cards (coming soon)',
  quotaSms: 'SMS (coming soon)',
  quotaStorage: 'Storage {n}',
  featureComingSoon: 'Coming soon',
  adminTitle: 'Membership plan admin',
  adminDesc: 'Platform admins configure plan tiers. 0 means unlimited for that quota. Platform plans are sold publicly; custom plans are granted by invitation. Unlisted plans cannot be purchased; existing subscriptions stay.',
  addPlan: 'New plan',
  editPlan: 'Edit plan',
  name: 'Name',
  tag: 'Tag',
  tagPlaceholder: 'e.g. Popular, Recommended',
  tagHint: 'Shown on plan cards in Upgrade or custom plan. Optional.',
  description: 'Description',
  features: 'Included features',
  featuresPlaceholder: 'One item per line, e.g.\nMicrosite builder\nRegistration forms\nPhoto Live',
  featuresHint: 'Display only on the plan page; does not change permissions. One item per line, up to 30.',
  priceYuan: 'Price (CNY)',
  duration: 'Term',
  maxActivities: 'Event limit',
  maxAlbums: 'Photo Live',
  maxRegistrations: 'Forms',
  maxDonations: 'Donations',
  maxNameCards: 'Name cards',
  maxSms: 'SMS quota',
  quotaComingSoonHint: 'Coming soon',
  maxStorageGb: 'Storage limit (GB)',
  isDefault: 'Default tier',
  status: 'Status',
  statusOn: 'Listed',
  statusOff: 'Unlisted',
  sortOrder: 'Sort',
  save: 'Save',
  deleteConfirm: 'Delete plan “{name}”? It will disappear from the catalog; historical orders still keep the tier record.',
  defaultCannotDelete: 'There must be exactly one default tier. Set another platform plan as default before deleting or unchecking this one.',
  deleted: 'Plan deleted',
  grantTitle: 'Grant plan',
  grantCompany: 'Company',
  grantPlan: 'Plan',
  grantSuccess: 'Granted',
  payTitle: 'WeChat Pay',
  paySuccess: 'Paid',
  payAmount: 'Amount due',
  payScanTip: 'Scan the QR code with WeChat to pay',
  payCountdown: '{time} left',
  payFailed: 'Could not start payment',
  payNoCodeUrl: 'No QR code returned',
  payCancelled: 'Order cancelled. Please place a new one.',
  payCancel: 'Cancel payment',
  activationTitle: 'Activation records',
  activationDesc: 'Membership activations across companies. Amount is what was charged; admin grants show ￥0.',
  activationSearch: 'Search order ID, company, or plan',
  purchaseTitle: 'Plan purchases',
  purchaseDesc: 'This company’s plan orders, including unpaid and cancelled.',
  colOrderId: 'Order ID',
  colCompany: 'Company / organization',
  colPlanName: 'Plan',
  colAmount: 'Amount',
  colPayMethod: 'Payment method',
  colActivatedAt: 'Activated at',
  colChargedAt: 'Charged at',
  colPayStatus: 'Status',
  payMethodWechat: 'WeChat Pay',
  payMethodAdmin: 'Admin grant',
  payMethodFree: 'Free',
  subActive: 'Active',
  subExpiring: 'Expiring soon',
  subExpired: 'Expired',
  orderPaid: 'Paid',
  orderPending: 'Unpaid',
  orderCancelled: 'Cancelled',
  zeroHint: '0 means unlimited',
  category: 'Category',
  categoryPlatform: 'Platform plan',
  categoryCustom: 'Custom plan',
  categoryPlatformHint: 'Sold publicly on the website, to companies, and to event liaisons',
  categoryCustomHint: 'Activated by invitation only; not listed in self-serve checkout',
  allowCustomFooterLogo: 'Custom footer logo',
  allowCustomFooterLogoHint: 'Companies on this plan can replace the activity page footer logo',
  perkLogoOn: 'Custom activity footer logo',
  perkLogoOff: 'Platform default footer logo',
  masterExemptTitle: 'Internal platform company',
  masterExempt: 'This is the internal super-admin company. It is not limited by membership plans and does not need to purchase one.'
}
